import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isArray } from 'lodash-es'
import Alerts from 'utils/Alerts'

/**
 * Simple "constant" to make it easier to transmit fake links in an alert.
 * @constant
 */
export const ALERT_FAKE_LINK = 0 //0 so it blends well with order IDs

/**
 * @param dispatch
 * @param ids {number|number[]|object[]}
 */
export function closeAlert (dispatch, ids) {
	/** @type number[] */
	let rawIds = []
	if (typeof ids == 'number') {
		rawIds = [ids]
	} else if (isArray(ids) && typeof ids[0] == 'object') {
		rawIds = ids.map(obj => obj.id)
	} //else, it's already an array of numbers (if typing was respected, of course)

	rawIds.forEach(id => Alerts.remove(id))
}

export function useAlertActions(id, link, superClose = null) {
	const dispatch = useDispatch()
	const history  = useHistory()
	let isClosing  = false //poor man's preventBubbling

	const onClose = () => {
		isClosing = true
		superClose? superClose() : closeAlert(dispatch, id)
	}

	const onClick = () => {
		if (isClosing) {
			return false //AKA preventBubbling
		}
		if (link && link !== ALERT_FAKE_LINK) {
			history.push(link)
		} else {
			console.debug('clicked an empty/fake link')
		}
		onClose()
	}

	return [onClick, onClose]
}
